import { compose } from 'recompose';
import apiInterceptor from '../../../api/interceptor';
import SRNReport from './SRNReport';
import { srnReportApi } from '../../common/base.api';

const composedSRNReport = compose(apiInterceptor({ ...srnReportApi }))(SRNReport);

export default composedSRNReport;
